
export const COLORS = {
chartTa1: '#0080FF',
  chartTa2: '#AA2211',
  chartTa3: '#9933FF',
  chartTa4: '#FFB0B0',
  chartTa5: '#449999',
  chartTa6: '#FF3399',
  chartTa7: '#FF9900',
  chartTa8: '#9AA1A9',

chartCompare1: '#2196F3',
  chartCompare2: '#FF9800',
  chartCompare3: '#4CAF50',
  chartCompare4: '#E91E63',
  chartCompare5: '#9C27B0',
  chartCompare6: '#00BCD4',
  chartCompare7: '#FF5722',
  chartCompare8: '#8BC34A',

textUpColor: '#1c7d45',
  textDownColor: '#b71c15',

assetCashDark: '#8B73B6',
  heatmapRange5: '#2b3c8f',

chartDrawingDefault: '#F44336',
} as const;

export function resolveColor(value: string): string {
  if (!value.startsWith('var(')) return value;

  // Extract variable name from var(--name) or var(--name, fallback)
  const match = value.match(/var\(\s*(--[^,)]+)/);
  if (!match) return value;

  const varName = match[1];
  const computed = getComputedStyle(document.documentElement)
    .getPropertyValue(varName)
    .trim();

  return computed || value;
}

export function resolveHex(value: string): string {
  return resolveColor(value).replace('#', '');
}
